import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// v74 — admin-only footer links; labels and addresses come from the server, only for admins.
export function AdminFooterLink() {
  const { user } = useAuth();
  const [links, setLinks] = useState([]);
  useEffect(() => {
    if (!user?.is_super_admin) { setLinks([]); return; }
    api.get("/admin/footer-links").then(({ data }) => setLinks(data)).catch(() => setLinks([]));
  }, [user?.is_super_admin]);
  return links.map((l, i) => (
    <a key={l.path} href={`${process.env.REACT_APP_BACKEND_URL}${l.path}`} target="_blank" rel="noopener noreferrer"
      data-testid={`footer-admin-link-${i}`} className="text-zinc-600 hover:text-zinc-300 transition-colors duration-150">
      {l.label}
    </a>
  ));
}
